import React from 'react';
import { Pie } from 'react-chartjs-2';

const ImprintChart = ({ chartSize, labels, datasets }) => (
  <Pie
    width={chartSize}
    height={chartSize}
    data={{ labels, datasets }}
    options={{
      legend: { display: false },
      maintainAspectRatio: false,
    }}
  />
);

export default ImprintChart;
